export const UPLOADED_FILE_EXTENSIONS = ["docx", "txt", "pdf", "xlsx", "md"];
